import { redirect } from "@remix-run/server-runtime";

import type { UserExtendedView } from "@wind/user";

import AuthLinkGenerator from "./AuthLinkGenerator.js";

const AUTH_PATHS = ["/s", "/accept", "/admin"];

/**
 * Utility for checking paths for authentication related pages
 *
 * @author @mxs2019
 */
class AuthPathUtil {
  // If it's an authed path and the user hasn't accepted terms, redirect to signup
  static redirectToSignupIfNeeded(user: UserExtendedView, request: Request) {
    const url = new URL(request.url);
    const path = url.pathname;

    const isSignupPath = AuthPathUtil.isSignupPath(path);

    if (!user.termsAcceptedAt && !isSignupPath) {
      throw redirect(AuthLinkGenerator.makeSignupPath(request));
    }
  }

  static isAuthedPath(path: string) {
    return AUTH_PATHS.some((authPath) => path === authPath || path.startsWith(authPath + "/"));
  }

  static isWorkspacePath(path: string) {
    return path.startsWith("/s/");
  }

  static isSignupPath(path: string) {
    // We don't want to redirect on the `/s/new` page since user will accept TOS there
    return path === "/s/signup" || path === "/s/new";
  }

  static isAdminPath(path: string) {
    return path.startsWith("/admin");
  }
}

export default AuthPathUtil;
